class BaoProductRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.observeForShopifyRecommendations()
  }

  observeForShopifyRecommendations () {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)
        this.fetchShopifyRecommendations()
      },
      {
        rootMargin: '0px 0px 500px 0px',
      },
    )

    observer.observe(this)
  }

  async fetchShopifyRecommendations () {
    if (!this.productId) return

    try {
      const response = await fetch(
        `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=related`,
      )
      const text = await response.text()
      const html = new DOMParser().parseFromString(text, 'text/html')
      const recommendations = html.querySelector('bao-product-recommendations')

      if (recommendations && recommendations.innerHTML.trim()) {
        this.innerHTML = recommendations.innerHTML
      }

      document.dispatchEvent(new CustomEvent('checkIsInWishlist'))
    } catch (error) {
      this.throwError(error.message)
    }
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('bao-product-recommendations')) {
  customElements.define(
    'bao-product-recommendations',
    BaoProductRecommendations,
  )
}
